'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default ['$scope', '$uibModalInstance', 'phase', 'PhaseService', 'ModalService', '$security', 'StatusService',
    function ($scope, $modalInstance, phase, PhaseService, ModalService, $security, StatusService) {

        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.editing = editing;
        $scope.isShowEdit = isShowEdit;
        $scope.checkUniqueName = checkUniqueName;

        init();

        // region Function

        function init() {
            $scope.edit = false;
            $scope.uniqueName = true;
            // копирование
            $scope.phase = angular.copy(phase);

            // Определение заголовка модального окна
            if (phase == null || phase.id == null) {
                $scope.title = "Создание нового этапа проекта";
                $scope.edit = true;
            } else {
                $scope.title = 'Редактирование этапа проекта "' + phase.name + '"';
                $scope.edit = true;
            }

            StatusService.api.default(null, (data) => {
                if (!$scope.phase.status)
                    $scope.phase.status = data._embedded;
            });
        }

        function checkUniqueName(name) {
            if (name != null && name.trim() != "") {
                PhaseService.api.exists({
                    filters: (($scope) => {
                        let filters = [];
                        filters.push("'name' EQ '" + $scope.phase.name + "'");
                        if ($scope.phase.id) {
                            filters.push("'id' NE '" + $scope.phase.id + "'");
                        }
                        return filters;
                    })($scope)
                }, (data) => {
                    $scope.uniqueName = !data._embedded;
                });
            } else {
                $scope.uniqueLogin = true;
            }
        }

        /**
         * Success
         */
        function ok() {
            $modalInstance.close($scope.phase);
        }

        /**
         * Dismiss
         */
        function cancel() {
            $modalInstance.dismiss();
        }

        /**
         * Редактировать
         */
        function editing() {
            $scope.edit = true;
        }

        /**
         * Отображать кнопку редактировать?
         * @returns {boolean|*}
         */
        function isShowEdit() {
            return !$scope.edit && $security.isAllowWrite('/src-categories');
        }

        // endregion

    }];